import script from "./tab-menu.vue?vue&type=script&setup=true&lang=ts"
export * from "./tab-menu.vue?vue&type=script&setup=true&lang=ts"

import "./tab-menu.vue?vue&type=style&index=0&id=021e98a7&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-021e98a7"]])

export default __exports__